import { Node } from 'ts-morph'

export function getPropertyNameForInitializer(node: Node): string | null {
  const parent = node.getParent()
  if (!parent) {
    return null
  }

  if (Node.isPropertyAssignment(parent) && parent.getInitializer() === node) {
    return parent.getName()
  }

  return null
}
